// extracted by mini-css-extract-plugin
export default {"odds":"_3fqFJWGEgeDCFAG56iaQ6k","outcome":"_23vhV68qbvA-YzeusO36WV","type":"_2-l6MfFI4Llk1SOpmwrNWT","hot":"_3MCtLp6xfdd2c3N64oAnRm"};